import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'documents/document';
const wizardName = 'Generic File association';
const wizardObject = 'Document';
const wizardAction = 'genericFileAssociation';

const GenericFileAssociation = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);

    // DATA PROVIDER
    const {
        item,
        save,
        errorMessage,
        errors,
        saving,
        success
    } = useDataProvider(dataProviderName, true);

    const modelName = existingModules.modelName

    const detailConfig = {
        "tabs": [
            {
                "name": "document",
                "fieldsets": [
                    {
                        "name": "document",
                        "fields": {
                            "file": {
                                "type": "dropzone",
                                "required":true,
                                "className": "col-12",
                                "icon": "faFile"
                            },
                            "type": {
                                "type": "select",
                                "required":true,
                                "options": [
                                    {
                                        "label": "configuration",
                                        "value": "configuration"
                                    },
                                    {
                                        "label": "singleOfferDocument",
                                        "value": "singleOfferDocument"
                                    },
                                    {
                                        "label": "orderForm",
                                        "value": "orderForm"
                                    },
                                    {
                                        "label": "mad",
                                        "value": "mad"
                                    },
                                    {
                                        "label": "deliveryDocument",
                                        "value": "deliveryDocument"
                                    },
                                    {
                                        "label": "returnReport",
                                        "value": "returnReport"
                                    },
                                ],
                                "className": "col-12",
                                "icon": "faCircleX"
                            },
                            "contract": {
                                "type": "relationshipSingle",
                                "relation": {
                                    "drawerRoute": "contracts"
                                },
                                "view": "contract"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    // DOCUMENT ****NON USA**** QUESTO PROCESSO DI CREAZIONE TRAMITE JOB
    // 
    // const handleSave = (data) => {
    //     doAction({action: wizardAction, model: dataProviderName, data: data}).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    // }

    const handleSave = async (data) => {
        save && save({ ...data, filters: params.filters }).then(() => {close()})
    }
    
    const contract = params?.contract || params?.parent;
    return <>
        <DetailComponent
            values={{
                "id": item?.data?._id,
                "contract": contract,
                "visibleToDriver": "false",
                "name": t("document") + (contract?.contractIdentifier ? ' ' + contract?.contractIdentifier : '')
            }}
            modelName={modelName}
            detailConfig={detailConfig}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Add a {{wizardObject}} to {{contractIdentifier}}', { wizardObject: wizardObject, contractIdentifier: contract?.contractIdentifier })}
                />
            }
            {...params}
        />
    </>
}

export default GenericFileAssociation;


